<template>
  <div>
    <v-form>
      <v-btn
        v-if="btnTrigger"
        color="primary"
        :disabled="disabled"
        @click="fileOnFocus"><v-icon
          small
          class="pr-1">{{ icon }}</v-icon> {{ label }}</v-btn>
      <a
        v-else-if="linkTrigger"
        flat
        @click="fileOnFocus">{{ label }}</a>
      <v-text-field
        v-else
        v-model="filename"
        ref="fileTextField"
        :label="label"
        :required="required"
        :disabled="disabled"
        single-line
        @click.native="fileOnFocus"/>
      <input
        ref="fileInput"
        :accept="accept"
        :multiple="false"
        :disabled="disabled"
        type="file"
        @change="onFileChange">
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
input[type="file"] {
  position: absolute;
  left: -99999px;
}
</style>

<script>
export default {
  props: {
    value: {
      type: [Array, String]
    },
    accept: {
      type: String,
      default: '*'
    },
    label: {
      type: String,
      default: 'Please choose...'
    },
    icon: {
      type: String,
      default: 'camera_alt'
    },
    fieldName: {
      type: String,
      default: 'profile_photo'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean, // not yet possible because of data
      default: false
    },
    linkTrigger: {
      type: Boolean,
      default: false
    },
    btnTrigger: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filename: ''
    }
  },
  watch: {
    value (v) {
      this.filename = v
    }
  },
  mounted () {
    this.filename = this.value
  },

  methods: {
    getFormData (files) {
      const data = new FormData();
      [...files].forEach(file => {
        data.append(this.fieldName, file, file.name) // currently only one file at a time
      })
      return data
    },
    fileOnFocus () {
      if (!this.disabled) {
        this.$refs.fileInput.click()
      }
    },
    onFileChange ($event) {
      const files = $event.target.files || $event.dataTransfer.files
      var form = this.getFormData(files)
      if (files) {
        if (files.length > 0) {
          this.filename = [...files].map(file => file.name).join(', ')
        } else {
          this.filename = null
        }
      } else {
        this.filename = $event.target.value.split('\\').pop()
      }
      this.$emit('input', this.filename)
      this.$emit('formData', form)
      $event.target.value = '';
    }
  }
}
</script>
